const isNull = (param) => param === null

class Level {
  constructor({
    levelName = null,
    levelId = null,
    groupId = null,
    groupName = null
  } = {}) {
    this.levelName = isNull(levelName) ? null : levelName;
    this.levelId = isNull(levelId) ? null : levelId;
    this.groupId = isNull(groupId) ? null : groupId;
    this.groupName = isNull(groupName) ? null : groupName

  }

  copyWith({
    levelName = null,
    levelId = null,
    groupId = null,
    groupName = null
  } = {}) {
    return new Level({
      levelName: isNull(levelName) ? this.levelName : levelName,
      levelId: isNull(levelId) ? this.levelId : levelId,
      groupId: isNull(groupId) ? this.groupId : groupId,
      groupName: isNull(groupName) ? this.groupName : groupName
    })
  }
}

export const parseLevels = ({ levels } = {}) => levels.map((e) => new Level({ levelId: e.id, levelName: e.typeLevel }))
export const parseGroups = ({ gradeGroups } = {}) => gradeGroups.map((e) => e.gradeGroups.map((x) => new Level({ groupId: x.id, levelId: e.id, groupName: `${x.grade} ${x.group}` }))).flat()
/**
 * levelIds - Is a list of levelsIds
 * 
 * posibleGroups - Receives a is a list of groups(all posible groups)
 * 
 * Return a list of groups 
 * */
export const filterByLevel = ({ levelIds = [], posibleGroups = [] }) => levelIds.map((e) => posibleGroups.filter((x) => x.levelId == e)).flat()
/**
 * 
 * Return a list of levels
 */
export const filterByGroup = ({ groupsIds = [], posibleGroups = [], posibleLevels = [] }) => {
  const selectedGroupsLevelsIds = Array.from(new Set(groupsIds.map((e) => posibleGroups.filter((a) => a.groupId === e)).flat().map((e) => e.levelId)))
  const levels = selectedGroupsLevelsIds.map((e) => posibleLevels.filter((x) => x.levelId === e)).flat()
  return levels
}

export const isEmpty = (array = []) => array.length === 0
export const isNotEmpty = (array = []) => array.length !== 0